import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import axios from "axios";
import {schoolJobsurl} from '../../../apis/urls'
import { jobscategorycreate } from '../../../apis/urls'
import {decode} from 'html-entities';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


const ViewJob = () => {

    useEffect(() => {
        JobListing();
        
    },[]
    );



    const { id,jobid } = useParams();
    const[ result,setResult ] = useState('');
    const[ jobCat,setJobcat ] = useState('');

    const JobListing = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: schoolJobsurl+'/'+id+'/'+jobid,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            //console.log(res.data.data)
            setResult(res.data.data);
            JobCategory(res.data.data.job_category_id);
          });

    }

    const JobCategory = (jid)=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: jobscategorycreate+'/'+jid,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            
            //console.log('jobcat',res.data.data.name)
            setJobcat(res.data.data.name);
          });

    }
const desc = decode(result.description);
 const decrypted_desc = desc.replace(/<.+?>/g, '');console.log('descrrr',decrypted_desc)

    return(
        <div>
            <aside class="right-side areas">    
                <div class="content-area dash-contentss">
                   
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Job</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to={"/jobs/"+id}>Job</Link></li>
                            <li className="breadcrumb-item"><Link to={"/jobview/"+id+"/"+result.id}>Job View</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Job View({result.title})</li>
                            
                        </ol>
                    </nav>


                    <div class="jumbotron description-view">
                        <div id="generalinfo" class="container tab-pane active">
                            <div class="rows tab-sections">
                            <div>
                            <h4 className="jobview-label">Description</h4><br />
                                <p>{ReactHtmlParser(desc)}</p>
                            </div>
                                <Link className="description-texts" to={"/jobview/"+id+"/"+result.id}>Read Less</Link>
                            </div>           
                        </div>
                    </div>
                                                        



                </div>
            </aside>

        </div>
    )
}

export default ViewJob;